export const environment = {
  production: false,
  WIDGET_API_URI: 'https://localhost:44381/api/'
};